import { render, staticRenderFns } from "./Popups.vue?vue&type=template&id=4452dca6&"
import script from "./Popups.vue?vue&type=script&lang=js&"
export * from "./Popups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4452dca6')) {
      api.createRecord('4452dca6', component.options)
    } else {
      api.reload('4452dca6', component.options)
    }
    module.hot.accept("./Popups.vue?vue&type=template&id=4452dca6&", function () {
      api.rerender('4452dca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/popups/Popups.vue"
export default component.exports